import { oz } from '@weft/utils';
import { NotificationEntityTypeSchema } from './notification-entity-type-schema';

export const NotificationEntitySchema = oz.object({
  entityId: oz.string(),
  type: NotificationEntityTypeSchema,
}).openapi('NotificationEntity');

export type NotificationEntity = oz.infer<typeof NotificationEntitySchema>;